"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prodInfoNullTextList = void 0;
const judge = (flag, trueText, falseText) => {
    return flag ? trueText : falseText;
};
exports.prodInfoNullTextList = [
    {
        label: "合同号",
        judgement: "shippingStatus",
        value: (flag) => {
            return judge(flag, "尚未发货", "数据缺失");
        },
    },
    { label: "销售订单号", judgement: "", value: "尚未发货" },
    { label: "生产工单号", judgement: "", value: "数据缺失" },
    { label: "制令单号", judgement: "", value: "数据缺失" },
    {
        label: "交货单号",
        judgement: "shippingStatus",
        value: (flag) => {
            return judge(flag, "尚未发货", "请看发货通知单号");
        },
    },
    {
        label: "物流单号",
        judgement: "shippingStatus",
        value: (flag) => {
            return judge(flag, "尚未发货", "数据缺失");
        },
    },
    {
        label: "收货地所属省份",
        judgement: "shippingStatus",
        value: (flag) => {
            return judge(flag, "尚未发货", "数据缺失");
        },
    },
    {
        label: "收货地所属城市",
        judgement: "shippingStatus",
        value: (flag) => {
            return judge(flag, "尚未发货", "数据缺失");
        },
    },
    {
        label: "安装地点",
        judgement: "shippingStatus",
        value: (flag) => {
            return judge(flag, "尚未发货", "数据缺失");
        },
    },
    { label: "设备上线时间", judgement: "", value: "数据缺失" },
    {
        label: "故障次数",
        judgement: "shippingStatus",
        value: (flag) => {
            return judge(flag, "尚未发货", "数据缺失");
        },
    },
    {
        label: "故障工单号",
        judgement: "shippingStatus",
        value: (flag) => {
            return judge(flag, "尚未发货", "数据缺失");
        },
    },
    { label: "产品SN码", judgement: "", value: "数据缺失" },
    { label: "桩二维码", judgement: "", value: "数据缺失" },
    { label: "一级物料编码", judgement: "", value: "数据缺失" },
    { label: "规格型号", judgement: "", value: "数据缺失" },
    { label: "产品组", judgement: "", value: "数据缺失" },
    { label: "额定功率", judgement: "", value: "数据缺失" },
    { label: "枪数", judgement: "", value: "统计有误" },
    { label: "枪二维码", judgement: "", value: "数据缺失" },
    { label: "SIM码", judgement: "", value: "无SIM卡" },
    { label: "蓝牙PIN码", judgement: "", value: "不支持蓝牙" },
    { label: "主板程序版本", judgement: "", value: "数据缺失" },
    { label: "主板SN", judgement: "", value: "数据缺失" },
    { label: "充电枪SN", judgement: "", value: "数据缺失" },
];
